import localforage from 'localforage';
import moment from 'moment';
import { getRecentOrdersForSyncQuery } from '@msales/shared/graphql/queries/report/getRecentOrdersForSync';

const customerOrdersStore = localforage.createInstance({
  name: 'CustomerOrders',
});

export const syncCustomerOrders = async (client) => {
  try {
    const { data } = await client.query({
      query: getRecentOrdersForSyncQuery,
      variables: { perCustomer: 3 },
      fetchPolicy: 'no-cache',
    });

    const orders = data?.getRecentOrdersForSync || [];

    const grouped = {};
    for (const order of orders) {
      const cid = String(order.customerId);
      if (!grouped[cid]) grouped[cid] = [];
      grouped[cid].push(order);
    }

    await customerOrdersStore.setItem('orders', grouped);
    await customerOrdersStore.setItem(
      'createdAt',
      moment().format('DD/MM/YYYY HH:mm:ss'),
    );
  } catch (err) {
    console.warn('[AsyncCustomerOrders] Sync failed:', err.message);
  }
};

export const getCustomerOrdersFromCache = async (customerId) => {
  try {
    const grouped = await customerOrdersStore.getItem('orders');
    if (!grouped) return [];
    return grouped[String(customerId)] || [];
  } catch {
    return [];
  }
};
